var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsS3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188 36.5H72C54.603 36.5 40.5 50.603 40.5 68V184C40.5 201.397 54.603 215.5 72 215.5H188C205.397 215.5 219.5 201.397 219.5 184V68C219.5 50.603 205.397 36.5 188 36.5Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 76H180V176H80V76Z",
    fill: "url(#paint0_linear_1_25)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.185 132.677L155.685 129.425C159.943 131.965 160.023 133.035 160.015 133.075C160.005 133.082 159.245 133.675 155.185 132.677ZM129.722 123.345C129.722 124.003 129.461 124.634 128.996 125.1C128.531 125.565 127.9 125.828 127.242 125.83C126.583 125.83 125.95 125.568 125.484 125.101C125.017 124.635 124.755 124.002 124.755 123.343C124.755 122.683 125.017 122.05 125.484 121.584C125.95 121.117 126.583 120.855 127.242 120.855C128.61 120.855 129.722 121.975 129.722 123.345ZM149.395 154.17C149.395 154.477 148.157 154.945 147.07 155.365L145.957 155.79C144.77 156.263 143.365 156.687 141.785 157.05C137.845 157.965 132.41 158.513 127.242 158.513C113.485 158.513 106.155 155.99 106.145 154.018L100.64 109.925C105.387 113.555 115.14 115.88 127.242 115.88C138.817 115.88 150.653 113.637 156.203 109.7L152.787 132C145.61 129.815 136.807 125.6 132.457 123.505L132.195 123.38L132.2 123.343C132.2 120.598 129.975 118.368 127.242 118.368C125.926 118.371 124.664 118.897 123.734 119.829C122.805 120.762 122.284 122.026 122.285 123.343C122.285 126.085 124.51 128.318 127.242 128.318C129.075 128.318 130.66 127.3 131.518 125.812C136.033 127.982 145.042 132.29 152.407 134.482L149.395 154.17ZM127.245 95.9875C143.935 95.9875 156.887 100.638 156.98 104.65L156.92 105.02C156.245 108.967 143.54 113.395 127.245 113.395C111.275 113.395 100.47 109.083 100.02 104.958L99.9825 104.658C100.04 100.463 110.975 95.9875 127.242 95.9875H127.245ZM156.09 126.782L159.45 104.883C159.453 104.818 159.465 104.758 159.465 104.693C159.465 97.685 143.082 93.5 127.242 93.5C110.007 93.5 97.5 98.2075 97.5 104.693L97.5075 104.845L103.677 154.17C103.677 160.67 123.307 161 127.242 161C132.585 161 138.228 160.43 142.343 159.475C143.883 159.131 145.395 158.673 146.867 158.105L147.948 157.687C150.058 156.885 151.873 156.192 151.858 154.36L154.808 135.15C156.445 135.545 157.8 135.75 158.882 135.75C160.332 135.747 161.315 135.393 161.908 134.68C162.151 134.398 162.326 134.064 162.421 133.703C162.516 133.343 162.528 132.966 162.455 132.6C162.137 130.897 160.148 129.087 156.09 126.782Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_25",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_25",
    x1: 80,
    y1: 10076,
    x2: 10080,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B660F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CAE3E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsS3);
export default __webpack_public_path__ + "static/media/aws-s3.4ff7c5e982a3b3cb7f26d89022b760e8.svg";
export { ForwardRef as ReactComponent };